import { FormattedMessage, useIntl } from "react-intl";
import { Box, SelectChangeEvent, Typography } from "@mui/material";

import { RevbellSelect } from "../../../components/Inputs/RevbellSelect";
import { DisplayDelayType } from "../../interfaces";
import { memo } from "react";

const Options = [
  {
    label: (
      <Typography>
        <FormattedMessage id="BANNER_NO_DISPLAY_DELAY" />
      </Typography>
    ),
    value: 0,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_SINGULAR"
          values={{
            value: 1,
          }}
        />
      </Typography>
    ),
    value: 1,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 2,
          }}
        />
      </Typography>
    ),
    value: 2,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 3,
          }}
        />
      </Typography>
    ),
    value: 3,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 4,
          }}
        />
      </Typography>
    ),
    value: 4,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 5,
          }}
        />
      </Typography>
    ),
    value: 5,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 6,
          }}
        />
      </Typography>
    ),
    value: 6,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 7,
          }}
        />
      </Typography>
    ),
    value: 7,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 10,
          }}
        />
      </Typography>
    ),
    value: 10,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 14,
          }}
        />
      </Typography>
    ),
    value: 14,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 20,
          }}
        />
      </Typography>
    ),
    value: 20,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 30,
          }}
        />
      </Typography>
    ),
    value: 30,
  },
  {
    label: (
      <Typography>
        <FormattedMessage
          id="BANNER_DISPLAY_DELAY_OPTION_PLURAL"
          values={{
            value: 90,
          }}
        />
      </Typography>
    ),
    value: 90,
  },
];

const DisplayDelaySelector = memo(
  ({
    defaultValue,
    error,
    isPinned,
    onBannerDisplayChange,
  }: {
    defaultValue?: DisplayDelayType;
    error?: string;
    isPinned: boolean;
    onBannerDisplayChange: (contents: DisplayDelayType) => void;
  }) => {
    const intl = useIntl();

    const handleChange = (event: SelectChangeEvent<unknown>) => {
      const value = event.target.value as DisplayDelayType;
      onBannerDisplayChange(value);
    };

    return (
      <Box>
        <RevbellSelect
          defaultValue={defaultValue ?? ""}
          disabled={isPinned}
          fullWidth
          label={intl.formatMessage({
            id: "BANNER_DISPLAY_DELAY_SELECTOR_LABEL",
          })}
          tooltip={"BANNER_DISPLAY_DELAY_SELECTOR_TOOLTIP"}
          options={Options}
          onChange={handleChange}
          formControlSx={{ width: "100%" }}
          sx={{
            borderRadius: "4px !important",
            width: "100%",
            "& .MuiSelect-select": { padding: "6px 39px 6px 6px" },
          }}
        />
        {error && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.75rem",
              ml: 1.75,
            }}
          >
            <FormattedMessage id={error} />
          </Typography>
        )}
      </Box>
    );
  }
);

export default DisplayDelaySelector;
